import React, { useEffect, useMemo, useRef } from 'react';
import { Popup } from 'devextreme-react/popup';
import ScrollView from 'devextreme-react/scroll-view';
import DataGrid, { Column } from 'devextreme-react/data-grid';
import { Item as TabItem } from "devextreme-react/tab-panel";
import Form, { GroupItem, SimpleItem, Label, FormRef } from "devextreme-react/form";
import IDepot from "../../models/IDepot";
import { FormListBase, FormListBaseTab, FormListBaseGrid, FormListBaseToolbar } from '../base';
import { } from 'devextreme-react';
import useCustomDataSource, { Mode } from "../../hooks/useCustomDataSource";

export default function GestionDepots() {
  const depotFormDataSource = useCustomDataSource<IDepot, IDepot>({ path: "depot", primaryKey: "idDepot" });
  const { selectedDataRow: selectedDepot, mode, setMainForm, setMode, isFieldModifier, setIsFieldModifier, onFieldDataChanged } = depotFormDataSource;
  const formRef = useRef<FormRef>(null);
  //IPaiement changer
  //Select box Unité lookup -> unité, type unité, publicité, type de séjour, message
  useEffect(() => {
    setMainForm(formRef.current?.instance());
  })

  const btnOkOptions = useMemo(() => {
    return { text: "OK" };
  }, []);
  const btnAnnulerOptions = useMemo(() => {
    return { text: "Annuler" };
  }, []);

  return (
    <Popup
      visible={true}
      dragEnabled={true}
      hideOnOutsideClick={true}
      showCloseButton={false}
      showTitle={true}
      title="Liste des résidents"
      container=".dx-viewport"
      width={750}
      height={550}
    >
      <ScrollView width='100%' height='100%'>
        <FormListBase key={"frm-depot"} data={depotFormDataSource}>
          <FormListBaseGrid dataSource={depotFormDataSource.dataSource}
            onFocusedRowChanged={() => {
              if (mode === Mode.Modifier) {
                setMode(Mode.Lecture);
              }
            }}>
            <Column key={"grid-col-noDepot"} dataField={"noDepot"} caption="Description" allowHiding={false} />
          </FormListBaseGrid>
          <FormListBaseToolbar headerText={`${selectedDepot?.noDepot || ''}`} sauvegarderOptions={{ disabled: !isFieldModifier }} annulerOptions={{ disabled: !isFieldModifier }} />

          <FormListBaseTab>
            <TabItem title="Paiements">
              <Form ref={formRef} readOnly={mode === Mode.Lecture} alignItemLabelsInAllGroups={true} formData={selectedDepot || {} as IDepot} className={"forms"} labelLocation={"left"} showColonAfterLabel={true} onFieldDataChanged={onFieldDataChanged}>
                {/* <GroupItem colCount={6} alignItemLabels={true}>
                  <SimpleItem key={"frm-fichiers-joints"} editorType={"dxButton"} editorOptions={{ text: "TPV" }} />
                  <SimpleItem key={"frm-fichiers-joints"} editorType={"dxButton"} editorOptions={{ text: "Bambora" }} />
                  <SimpleItem key={"frm-message-defaut-type"} editorType={"dxButton"} editorOptions={{ text: "Certificat-Cadeau" }} />
                  <SimpleItem key={"frm-message-defaut-type"} editorType={"dxButton"} editorOptions={{ text: "Chèque" }} />
                  <SimpleItem key={"frm-message-defaut-type"} editorType={"dxButton"} editorOptions={{ text: "Comptant" }} />
                  <SimpleItem key={"frm-message-defaut-type"} editorType={"dxButton"} editorOptions={{ text: "Transfert de paiement" }} />
                  <SimpleItem key={"frm-message-defaut-type"} editorType={"dxButton"} editorOptions={{ text: "Virement Interac" }} />
                </GroupItem> */}
                <GroupItem>
                  <DataGrid showBorders={true} allowColumnResizing={true}>
                    <Column caption={"Type de Paiement"}>
                    </Column>
                    <Column caption={"Montant"}>
                    </Column>
                    <Column caption={"Référence"}>
                    </Column>
                    <Column caption={"Client"}>
                    </Column>
                    <Column caption={"Date de Paiement"}>
                    </Column>
                    <Column caption={"Usager"}>
                    </Column>
                    <Column caption={"Maj"}>
                    </Column>
                    <Column caption={"Z"} width={30}>
                    </Column>
                    <Column caption={"No. Reçu"}>
                    </Column>
                    <Column caption={"No. Dépôt"}>
                    </Column>
                  </DataGrid>
                </GroupItem>
                <GroupItem>
                  <SimpleItem key={"frm-button-solde"}>
                    <Label text={"Solde: 0.00"}></Label>
                  </SimpleItem>
                </GroupItem>
                <GroupItem colCount={2}>
                  <SimpleItem key={"frm-button-ok"}
                    editorOptions={
                      btnOkOptions
                    } />
                  <SimpleItem key={"frm-button-annuler"}
                    editorOptions={
                      btnAnnulerOptions
                    } />
                </GroupItem>
              </Form>
            </TabItem>
            <TabItem title="TPV">
            </TabItem>
            <TabItem title="Bambora">
            </TabItem>
            <TabItem title="Certificat-Cadeau">
            </TabItem>
            <TabItem title="Chèque">
            </TabItem>
            <TabItem title="Comptant">
            </TabItem>
            <TabItem title="Transfert de paiement">
            </TabItem>
            <TabItem title="Virement Interac">
            </TabItem>
          </FormListBaseTab>
        </FormListBase>
      </ScrollView>
    </Popup>
  );
}